import { render, staticRenderFns } from "./FormCancelar.vue?vue&type=template&id=a5e2c748&"
import script from "./FormCancelar.vue?vue&type=script&lang=js&"
export * from "./FormCancelar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports